import { useEffect, useCallback, useState } from 'react';
import cn from 'classnames';

const Tooltip: React.FC<React.PropsWithChildren<{ useTabStyle: boolean }>> = ({ children, useTabStyle }) => {
  const [mousePos, setMousePos] = useState<{ x: number; y: number } | null>(null);

  const onMove = useCallback((e: MouseEvent) => {
    setMousePos({ x: e.clientX, y: e.clientY });
  }, []);

  useEffect(() => {
    if (useTabStyle) return;
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, [onMove, useTabStyle]);

  return mousePos || useTabStyle ? (
    <div
      className={cn('tooltip', { 'tooltip--tab-triggered': useTabStyle })}
      style={
        mousePos
          ? {
              transform: `translate(${mousePos.x + 5}px, ${mousePos.y}px)`
            }
          : {}
      }
    >
      {children}
    </div>
  ) : null;
};

Tooltip.displayName = 'Tooltip';

export default Tooltip;
